export const AUTOLOGIN_ENDPOINTS = {
  appToken: '/authservice/api/v1/autologin/app-token/',
  validate: '/authservice/api/v1/autologin/validate/',
}

export const AUTOLOGIN_APP_TOKEN_TIMEOUT = 10000

export const AUTOLOGIN_TOKEN_PARAM = 'tkn'

export const AUTOLOGIN_BRIDGE_MESSAGE = 'AUTOLOGIN'

export const AUTOLOGIN_ERROR_CODES = {
  NETWORK: 'E004',
  SERVER: 'E005',
  UNKNOWN: 'E007',
}

export const AUTOLOGIN_EVENTS = {
  SUCCESS: 'auto_auth_success',
  FAILED: 'auto_auth_failed',
  MANUAL_AFTER_FAIL: 'manual_auth_after_fail',
}
